import { useSelector } from 'react-redux'
import { RootState } from 'redux/reducers'

export default function useNotification() {
  return useSelector((state: RootState) => state.common.notification)
}
